import { Component, OnInit,Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-textarea-addon',
  templateUrl: './textarea-addon.component.html',
  styleUrls: ['./textarea-addon.component.scss']
})
export class TextareaAddonComponent implements OnInit {
  @Input() public Content: any;
  heading: string;
  content: any;
  ViewMode: any;
  formFields;
  permission: string = "";
  textAreaForm: UntypedFormGroup;
  constructor(public modalRef: NgbActiveModal,
    private datashareService: IstDataShareService,
    public commonService: CommonService
) { }

  ngOnInit() {
     ;
      this.textAreaForm = new UntypedFormGroup({
      textEntry: new UntypedFormControl(this.Content.content, Validators.required)
    });
    let  TempPermission=this.commonService.getPagePermission("IST05");
    if (TempPermission != null && TempPermission != undefined) {
      this.permission = TempPermission.toLowerCase();
    }

    if (this.permission == "view") {
      this.textAreaForm.disable();
    }
  }
  SaveEntry() {
     
    if (this.textAreaForm.valid) {
      let Contenttext = this.textAreaForm.controls["textEntry"].value;
      switch (this.Content.heading) {
        case "OBJECTIVES":
          this.datashareService.setOBJECTIVES(Contenttext);
          break;
        case "HYPOTHESIS":
          this.datashareService.setHYPOTHESIS(Contenttext);
          break;
        case "BACKGROUND":
          this.datashareService.setBACKGROUND(Contenttext);
          break;
        case "Description of Subject Regulations":
          this.datashareService.setREGULATIONS(Contenttext);
          break;
        case "STUDY_DESIGN":
          this.datashareService.setSTUDY_DESIGN(Contenttext);
          break;
          case "Assessment Tools and Procedures":
             
          this.datashareService.setTOOLS_PROCEDURES(Contenttext);
          break;
          case "PRIMARY_OUTCOMES":
          this.datashareService.setPRIMARY_OUTCOMES(Contenttext);
          break;
          case "SECONDARY_OUTCOMES":
          this.datashareService.setSECONDARY_OUTCOMES(Contenttext);
          break;
      }
      this.modalRef.dismiss();
    }
  }
}
